import {
	type OpenModalAction,
	type CloseModalAction,
	CLOSE_MODAL,
	OPEN_MODAL,
} from '../../../actions/modals';
import type { ModalsState } from './types';

type Actions = OpenModalAction | CloseModalAction;

export const modalsReducer = (state: ModalsState = null, action: Actions): ModalsState => {
	switch (action.type) {
		case OPEN_MODAL:
			return action.payload;
		case CLOSE_MODAL:
			return null;
		default: {
			const _exhaustiveCheck: never = action;
			return state;
		}
	}
};
